(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["V_shoppable_videos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.video-list').forEach(function(elem){
        elem.querySelectorAll('.video-card').forEach(function(card){
            card.querySelector('.video-sound-btn').addEventListener('click', function(e) {
                e.preventDefault();
                let videoElement = card.getElementsByTagName('video')[0];
                if(card.classList.contains('muted')){
                    videoElement.muted = true;
                }
                else{
                    videoElement.muted = false;
                }
                card.classList.toggle('muted');
                });
        });

        new Swiper(elem, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            centeredSlides: false,
            loop: false,
            mousewheel: { forceToAxis: true },
            breakpoints: {
              0:    { spaceBetween: 8, centeredSlides: false, },
              480:  { spaceBetween: 8, centeredSlides: false, },
              600:  { spaceBetween: 8, centeredSlides: false, },
              1024: { spaceBetween: 12, centeredSlides: false, },
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-takes-space"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    if(document.querySelectorAll('.sec_pdp_shape .left-part .sec_shape_block').length > 0){
        document.querySelectorAll('.sec_pdp_shape .left-part div.sec_shape_block').forEach(function(elem){
            elem.onclick = function(){
                let index = elem.getAttribute('data-index');
                document.querySelector('.sec_pdp_shape .left-part div.sec_shape_block.active').classList.remove('active');
                document.querySelector('.sec_pdp_shape .right-part .sec_shape_block.active').classList.remove('active');
                elem.classList.toggle('active');
                document.querySelector('.sec_pdp_shape .right-part .sec_shape_block[data-index="'+index+'"]').classList.add('active');
            }
        })
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-week-pdp"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    var swiper = new Swiper(".timeline_thumb", {
        loop: false,
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: { forceToAxis: true },
        breakpoints: {
          0: {
            spaceBetween: 32 
          },
          768: {
            spaceBetween: 44
          }
        }
    });
    var swiper2 = new Swiper(".timeline_slider", {
        slidesPerView: 'auto',
        spaceBetween: 32,
        mousewheel: { forceToAxis: true },
        loop: true,
        breakpoints: {
          0: {
            spaceBetween: 8 
          },
          768: {
            spaceBetween: 32
          }
        },
        thumbs: {
            swiper: swiper,
        },
    });
});

  } catch(e) { console.error(e); }
})();
})();
